import styled from 'styled-components';

export const Container = styled.div`
  width: 210px;
  height: 201px;
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px 8px 0px 0px;
  border-bottom: 8px solid ${props => props.primaryColor || '#36397a'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
`;

export const NameBenefit = styled.h4`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #475467;
  flex-wrap: wrap;
  width: 120px;
`;

export const Circle = styled.div`
  width: 100px;
  height: 100px;
  background: #f2f4f7;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  svg {
    width: 40px !important;
    height: 30px;
    color: #475467;
  }
`;
